'use strict';

/*exported K2Timer */
/*exported K2TimerContainer */
/*globals Container */
/*globals formatedTime*/

function K2Timer(options) {
  this.startTime = null;
  this.timer = 0;
  this.timeout = null;
  this.options = null;

  this.init(options);
}

K2Timer.prototype = $.extend({}, {
  constructor: 'K2Timer',

  //**************************************************************************

  stopTimer: function stopTimer() {
    var _this = this;

    clearInterval(_this.timeout);

    return _this;
  },

  startTimer: function startTimer() {
    var _this = this;

    _this.startTime = new Date();
    _this.timer = 0;

    _this.timeout = setInterval(function () {
      _this.incTimer();
    }, _this.options.interval);

    return _this;
  },

  incTimer: function incTimer() {
    var _this = this;

    _this.timer += _this.options.interval;
    _this.options.$container.text(formatedTime(_this.timer, true));

    return _this;
  },

  //**************************************************************************
  init: function init(options) {
    var _this = this;

    var defaultOptions = {
      interval: 1000,
      $container: null
    };

    _this.options = $.extend({}, defaultOptions, options);

    return _this;
  }
});

function K2TimerContainer() {
  this.container = null;

  this.init();
}

K2TimerContainer.prototype = $.extend({}, {
  constructor: 'K2TimerContainer',

  //**************************************************************************

  hasTimer: function hasTimer(id) {
    var _this = this;

    return _this.container.has(id);
  },

  getTimer: function getTimer(id) {
    var _this = this;

    if (_this.hasTimer(id)) {
      return _this.container.get(id);
    }

    return null;
  },

  addTimer: function addTimer(id, options) {
    var _this = this;

    if (_this.hasTimer(id)) {
      _this.getTimer(id).stopTimer();
    }

    var timer = new K2Timer(options);
    _this.container.set(id, timer);

    return timer;
  },

  //**************************************************************************
  init: function init() {
    var _this = this;

    _this.container = new Container();

    return _this;
  }
});
